import { useQuery } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

// Agency-only — this agency's client locations, for the payer detail page's
// "Run charting" location picker.
export function useAgencyLocations() {
  const query = useQuery({
    queryKey: payerKeys.agencyLocations(),
    queryFn: () => payersApi.listAgencyLocations(),
  });
  return { locations: query.data ?? [], isLoading: query.isLoading };
}
